<template>
  <div v-cloak>
     <header>
          <div class="headerOne">
              <i class="el-icon-arrow-left" @click="goCardBag"></i>
              <span class="buss">{{msg}}</span>
          </div>
      </header>
      <div class="juzhong"></div>
      <ul id="ulOne">
          <li :style="{ 'background-image': 'url(' +bgSrc + ')','background-repeat':'no-repeat','background-size':'cover' }">
              <img src="../../assets/images/lone.png" alt="">
              <span class="card">{{cardInfo.cName}}</span>

              <div :class=" 'discount' +cardStyleId  ">
                  <span class="vip">{{active}}</span>
                      <div class="cententOne" v-show="showTrue" v-cloak>
                            <span class="number">{{absolute}}</span>
                            <span class="result">折</span>
                      </div>
              </div>
              <!-- 卡号 -->
                <div class="cardNumber">{{cardInfo.showIDPrefix}} {{cardInfo.cShowId}}</div>
          </li>
      </ul>
      <div class="circlOne" v-show="activeOne">
            <div class="circle" @click="getImg">
                <!-- 小二维码图片 -->
                <img src="../../assets/images/code.png"  @click="big">
            </div>
      </div>
      <div class="circlTwo" v-show="!activeOne">
          <!-- 二维码图片 -->
        <img :src="src">
        <div class="serial">{{cardInfo.showIDPrefix}} {{cardInfo.cShowId}}</div>
        <div class="produce">支付/充值/积分兑换礼品 请向老板出示此二维码</div>
        <div class="bott" @click="fold">
            <img src="../../assets/images/shangla.png" alt="">
            </div>
      </div>
      <div class="particulars ">
          <ul class="allOne">
              <li @click="goInfor" style="background-image: url('../../assets/images/bg-three.png')">
                  <!-- -->
                  <img src="../../assets/images/personage.png" alt="" >
                  <span>个人信息</span>
                  <span class="jifenOne">{{jifen}}积分</span>           
                  <img src="../../assets/images/goOn.png" alt="" class="goTo maginImg" >
              </li>
              <li @click="doDeal()">
                  <img src="../../assets/images/indent.png" alt="">
                   <span>交易查询</span>
                   <span class="jifenOne">{{rmbNum}}余额</span>         
                   <img src="../../assets/images/goOn.png" alt="" class="goTo maginImg">
              </li>
              <li @click="goInvite">
                   <img src="../../assets/images/link.png" alt="">
                   <span>邀请好友共同此卡优惠</span>
                   <img src="../../assets/images/goOn.png" alt="" class="goTo">
              </li>
          </ul>
      </div>
      <!-- 活动 -->
      <div class="active">
         <p>会员活动专区</p>
         <ul v-if="haveActive"> 
           <li v-for="(item,index) in list" :key="index" @click="goActive(item.description,item.insertTime,item.endTime,item.picName)">
               <!-- 商家活动图片 -->
                 <div v-if=" item.picName=='' ">
                      <img  :src="newSrc" class="imgOne">
                  </div>
                   <div v-if=" item.picName ">      
                    <img  :src="oldSrc+'&picName='+item.picName" class="imgOne">
                  </div>
                 <div class="content">
                   <div>{{item.description}}</div>
                   <div class="secondContent">有效期:{{item.insertTime}}——{{item.endTime}}</div>
                 </div>
           </li>
         </ul>
         <ul v-if="!haveActive">
           <li>该商家暂无设置任何活动</li>
         </ul>
      </div>
  </div>
</template>
<script>
import { Popup ,Toast } from 'mint-ui'
import { showCardAction } from '../../assets/js/api'

export default {
  data() {
    return {
      showTrue: true,
      msg: "",
      activeOne: true,
      cardInfo:[],              // 被选中的会员卡信息
      cShowId: "",
      //zhekou: localStorage.getItem("zhekou"),
      vipLevel: "",
      jifen: "",
      //vipNameOne:localStorage.getItem("vipName"),
      rmbNum: "",
      showIDPrefix: "",
      //cShowName: localStorage.getItem("cShowName"),
      src:"",
      cidNew:"",
      cardNewListOne:"",
      haveActive:true,
      list:[],
      newSrc:require("../../assets/images/photo.jpg"),
      oldSrc:"",
      cardStyleId:"",
      //cardStyleId:localStorage.getItem('cardStyleId'),
      //   cTypeIdOne: //用户在这个商家办的这种会员卡
      bgSrc:"" ,
      Toast: Toast({
          message: '加载中...',
          position: 'middle',
          duration: -1
        }),
    };
  },
  computed: {
    wsWbsocket() {
      return this.$store.state.wsWbsocket;
    }
  },
    methods: {
        goCardBag(){
           this.$router.push({
             name:"cardBag"
           })
        },
        checkHttpReturn(id)
            {
                        if(httpSendQue[id]==0)
                        {
                            var  self=this;
                            setTimeout(() => {
                                    if (self && !self._isDestroyed)
                                        self.checkHttpTimeOut();
                                }, newConfigTime);

                        }
                        else
                        {
                            delete httpSendQue[id];
                        }
                    },
          checkHttpTimeOut()
            {
                if(httpSendQue[id]==0)
                {
                    //  隐藏加载中
                      this.Toast.close()
                      Toast({
                            message: '网络不给力',
                            position: 'middle',
                            duration: 3000
                          })
                      

                }
            else
            {
                //删除数组中的id
                delete httpSendQue[id];

            }
        },
      goActive(description,insertTime,endTime,picName){
           var sid=this.$route.params.oneSid;
            this.$router.push({
                      path: "/activity",
                      query: {
                        description:description,
                          insertTime:insertTime,
                            endTime:endTime,
                          picName:picName,
                          sid:sid
                      }
                    });
      },
      goInvite(){
         this.$router.push({
          path: "/invite",
          query: {
                vipNameOne:this.vipNameOne,
                zhekou:this.zhekou,
                cShowName:this.cShowName,
                showIDPrefix:this.showIDPrefix,
                cShowId:this.cShowId,
                vipNameOne:this.vipNameOne,
                msg:this.msg,
                cidNew:this.cidNew,
                sid: this.$route.params.oneSid
          }
        });
      },
    //   获取单张二维码图片
      getImg(){
                var cid = localStorage.getItem("cid");
              
                axios.get(QrPath+"&uid="+uid+"&sign="+sign+"&cid="+cid+"&mode="+mode)
                .then(res=>{  
                
                  if(res.data.s==0){
                    console.log(11111,res)
                    this.src=getPhoto+"&filePath="+res.data.filePath+"&sign="+sign+"&uid="+uid+"&mode="+mode+"&cid="+cid
                  }
                      })
                .catch(error=>{
                  httpSendQue[id] = 1;   
                    this.Toast.close()
                        Toast({
                            message: '网络不给力',
                            position: 'middle',
                            duration:2000
                          })              
                            })
               
      },
      // 点击跳转到交易查询的页面
      doDeal() {
        var sidTwo = localStorage.getItem("sid");
        var cidTwo =localStorage.getItem("cid"); 
        // console.log(sidTwo,cidTwo)
        this.$router.push({
          path: "/deal",
          query: {
            rmbNum:this.rmbNum,
            sidTwo:sidTwo,
            cidTwo:cidTwo,
          }
        });
      },
      big(){
        this.activeOne = false;
        $(".circlTwo").animate({ height: "toggle", opacity: "toggle" }, "slow");

      },
      fold(){
          self=this;
        $(".circlTwo").animate({height: 'toggle', opacity: 'toggle'}, "slow",function(){
                  //  $(".circlOne").animate({height: 'toggle', opacity: 'toggle'}, "slow")
                    self.activeOne=true
                });
      },
      //点击跳转到拉去商户设置的vip各个等级的详细配置信息
      goInfor() {
        var sid = localStorage.getItem("sid");
        var cid = localStorage.getItem("cid"); 
        var cTypeIdOne =  localStorage.getItem("cTypeId"); 
        console.log(111, cTypeIdOne);
        
        this.$router.push({
          path: "/infor",
          query: {
            InfoOne: sid,
            InfoTne: cid,
            jifenOne: this.jifen,
            vipLevelOne: this.vipLevel, //vip等级
            cTypeIdTnre: cTypeIdOne //cTypeId
          }
        });
      },
  
    },
    created() {
         this.Toast
      },
    destroyed()
    {
      this.Toast.close()
    
    },
    mounted() {
      // 获取被选中卡的信息
      this.cardInfo = this.$store.state.selectedCardInfo;
      console.log("selectCard",this.cardInfo);
      // 获取卡片风格的id
      //var cardStyleId=localStorage.getItem("cardStyleId")
       // if(cardStyleId==3)
       // {
       //   this.bgSrc=require("../../assets/images/bg-three.png")
       // }
       // else if(cardStyleId==2)
       // {
       //    this.bgSrc=require("../../assets/images/bg-one.jpg")
       // }
       // else if(cardStyleId==1)
       // {
       //    this.bgSrc=require("../../assets/images/bg-two.jpg")
       // }

      // 获取商户信息
        var sid = localStorage.getItem("sid");
        var cid = localStorage.getItem("cid"); 
        this.cidNew=localStorage.getItem("cid");
        var self=this;
        showCardAction(this.sid).then(res=>{ 
                 httpSendQue[id] = 1; 
                  this.Toast.close();
                  if(res.data.s==0){
                         this.$store.commit("cardInformation",res.data)
                          var str = res.data.cShowId;
                          var str = str.replace(/(\d{4})/g, "$1 ").replace(/\s*$/, "");
                          this.cShowId = str;
                          this.showIDPrefix = res.data.showIDPrefix;
                          this.msg = res.data.shopName;
                          this.$store.commit("shopName", this.msg )
                          this.rmbNum =  res.data.rmbNum;
                          this.zhekou =  res.data.zheKou / 10;
                          if (this.zhekou == 10) {
                            this.showTrue = false;
                          }
                          // VIP等级
                          this.vipLevel =  res.data.vipLevel;
                          // 积分
                          this.jifen =  res.data.jiFen;
                        } 
                                
                  })
              .catch(error=>{
                      httpSendQue[id] = 1;   
                    this.Toast.close()
                        Toast({
                            message: '网络不给力',
                            position: 'middle',
                            duration:2000
                          })                      
                          })

        // 获取活动列表
         axios.get(listActivities+"&uid="+uid+"&sign="+sign+"&mode="+mode+"&sid="+sid+"&beginIdx="+0+"&maxRows="+100)
             .then(res=>{  
                 console.log(res)
                if(res.data.s==0){
                  this.list=res.data.list
                   for(var val of this.list){
                        if(val.picName !== ""){
                          console.log(val.picName)
                          var sid = this.$route.params.oneSid;
                          this.oldSrc=activePicture+"&sign="+sign+"&mode="+mode+"&sid="+sid+"&uid="+uid
                          // +"&picName="+val.picName
                          //   console.log( this.oldSrc)  
                          //   this.list.forEach((v,i)=>{this.$set(v,"src",this.oldSrc)})   
                        }
                    }
                }
                else if(res.data.s==1010)
                {
                   this.haveActive=false
                }
             })
        // 获取单个商户基本信息
            axios.get(shopInformation+"&uid="+uid+"&sid="+sid+"&sign="+sign+"&mode="+mode)
             .then(res=>{  
                 console.log("shopInformation",res)
                if(res.data.s==0){
                }

             })
   
  },
};

</script>
<style scoped>
.active p{
  font-size: 0.7rem;
  margin: 0.4rem 0 0.2rem 0.2rem ;
}
 .active  ul li {
   width: 90%;
   margin: 0 auto;
   box-shadow: 0 0.1rem 0.2rem 0 rgba(0,0,0,0.10);
   height:6.8rem;
   margin-bottom: 0.4rem
 }
.imgOne{
  width: 100%;
  height: 5rem;
  border-radius: 0.2rem;
  margin-left: 0 !important
}
.content{
   margin-top: 0.1rem;
   font-size: 0.45rem;
 margin-left: 0.2rem;
}
.secondContent{
  margin-top: 0.05rem;
   font-size: 0.4rem;
  color: rgba(0, 0, 0, 0.4)
}
.el-icon-arrow-left{
    font-size: 0.8rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
.maginImg {
  margin-left: 0rem !important;
  float: right;
  margin: 0.5rem 0.7rem 0 0;
}
.jifenOne {
  display: inline-block;
  width: 3.2rem;
  text-align: right;
  /* margin-left: 1.7rem; */
  vertical-align: top;
  color: rgba(0, 0, 0, 0.5);
}
header {
  height: 1.6rem;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  /* position: relative; */
  position: fixed;
  top: 0;
  left: 0;
  background: white;
}
.juzhong {
  height: 1.6rem;
  width: 100%;
}
.headerOne {
  font-size: 0;
}
.headerOne img {
  display: inline-block;
  margin-top: 0.3rem;
}
.headerOne img:nth-child(1) {
  margin-left: 0.2rem;
}
.headerOne .buss {
  display: inline-block;
  font-size: 0.55rem !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
ul#ulOne li {
  width: 95%;
  height: 6rem;
  background: red;
  margin: 0.2rem auto;
  border-radius: 0.4rem;
  /* background-image: url("../../assets/images/bg-three.png"); */
  background-repeat: no-repeat;
  background-size:100% 100%;

  font-size: 0;
  /* position: relative; */
}
ul li img {
  width:1rem;
  height: auto;
  vertical-align: middle;
  margin-left: 0.6rem;
}
ul li .card {
  font-size: 0.35rem;
  vertical-align: middle;
  color: white;
  margin-left: 0.2rem;
}
img,
.card {
  display: inline-block;
  margin-top: 0.2rem;
  font-size: 0.5rem !important
}

.cardNumber {
  font-size: 0.5rem;
  position: absolute;
  top:6.5rem;
  left: 0.6rem;
  color: white;
}
/* 青色 */
.discount3 {
  /* position: absolute; */
  height: 2.2rem;
  width: 1.5rem;
  background: #e80000;
  /* top: 1.2rem; */
  /* left: 5rem; */
  float: right;
  margin-right: 0.6rem;
  border-radius: 0.12rem;
}
.discount3 span:nth-child(1) {
  display: block;
  font-size: 0.36rem;
  margin-top: 0.28rem;
}
.discount3 .cententOne {
  text-align: center;
}
.discount3 .cententOne span:nth-child(1) {
  font-size: 0.6rem;
  padding-top: 0.28rem;
  /* font-weight: bold; */
  /* text-align: center; */
  /* margin-left: 0.25rem; */
  /* width: 1.4rem; */
  height: 0.7rem;
  width: auto;
  display: inline-block;
  margin-top: 0.05rem;
}
.discount3 span:nth-child(3) {
  /* position: absolute;
  top: 1.6rem;
  left: 1.1rem; */
  font-size: 0.25rem;
}
.discount3 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}

/* 绿色 */
.discount2 {
  /* position: absolute; */
  height: 2.2rem;
  width: 1.5rem;
  background:  #A4AC10;
  /* top: 1.2rem; */
  /* left: 5rem; */
  float: right;
  margin-right: 0.6rem;
  border-radius: 0.12rem;
}
.discount2 span:nth-child(1) {
  display: block;
  font-size: 0.36rem;
  margin-top: 0.28rem;
}
.discount2 .cententOne {
  text-align: center;
}
.discount2 .cententOne span:nth-child(1) {
  font-size: 0.6rem;
  padding-top: 0.28rem;
  /* font-weight: bold; */
  /* text-align: center; */
  /* margin-left: 0.25rem; */
  /* width: 1.4rem; */
  height: 0.7rem;
  width: auto;
  display: inline-block;
  margin-top: 0.05rem;
}
.discount2 span:nth-child(3) {
  /* position: absolute;
  top: 1.6rem;
  left: 1.1rem; */
  font-size: 0.25rem;
}
.discount2 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}

/* 青色 */
.discount1 {
  /* position: absolute; */
  height: 2.2rem;
  width: 1.5rem;
  background:  #85C4B5;
  /* top: 1.2rem; */
  /* left: 5rem; */
  float: right;
  margin-right: 0.6rem;
  border-radius: 0.12rem;
}
.discount1 span:nth-child(1) {
  display: block;
  font-size: 0.36rem;
  margin-top: 0.28rem;
}
.discount1 .cententOne {
  text-align: center;
}
.discount1 .cententOne span:nth-child(1) {
  font-size: 0.6rem;
  padding-top: 0.28rem;
  /* font-weight: bold; */
  /* text-align: center; */
  /* margin-left: 0.25rem; */
  /* width: 1.4rem; */
  height: 0.7rem;
  width: auto;
  display: inline-block;
  margin-top: 0.05rem;
}
.discount1 span:nth-child(3) {
  /* position: absolute;
  top: 1.6rem;
  left: 1.1rem; */
  font-size: 0.25rem;
}
.discount1 span {
  font-size: 0.2rem;
  color: white;
  text-align: center;
}

.circle {
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  background: white;
  top: 7.6rem;
  left:4.1rem;
  position: absolute;
}
.circle img {
  width: 1.2rem;
  height: auto;
  padding-left: 0.28rem;
  display: inline-block;
  position: absolute;
  top: 0rem;
  left: 0.02rem;
}
.circlOne {
  width: 100%;
  height: 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.circlTwo {
  width: 100%;
  height:6.3rem;
  /* background: gray; */
  border-bottom: 0.15rem solid rgba(0, 0, 0, 0.05);
}
.circlTwo img {
  width:4rem;
  height:4rem;
  display: block;
  margin: 0 auto;
}

.circlTwo .serial {
  font-size: 0.55rem;
  text-align: center;
  margin-top: 0.2rem;
}
.circlTwo .produce {
  font-size: 0.4rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.2);
  margin-top: 0.4rem;
}
.circlTwo .bott {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: white;
  margin-left:4.5rem

}
.circlTwo .bott img {
  width:1rem !important;
  height:1rem !important;
}
.particulars .allOne li {
  height: 1.7rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  /* position: relative; */
}
.particulars .allOne li .goTo {
  width: 0.4rem;
  height: auto;

}
.particulars .allOne li:nth-child(3) .goTo {
  margin-left: 1.18rem;
}
.particulars .allOne li:nth-child(3) {
  border-bottom: 0.15rem solid rgba(0, 0, 0, 0.05);
  /* position: relative; */
}
.particulars .allOne li img {
  vertical-align: middle;
  display: inline-block;
  margin-bottom: 0.4rem;
}
.particulars .allOne li span {
  font-size: 0.55rem;
  vertical-align: middle;
  margin-left: 0.34rem
}
</style>



// WEBPACK FOOTER //
// src/components/card/card.vue